/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-code.ux-code--theme-light {
  /* Code blocks */
  /* Inline code */
}
.ux-code.ux-code--theme-light code,
.ux-code.ux-code--theme-light pre {
  color: #000;
}
.ux-code.ux-code--theme-light pre,
.ux-code.ux-code--theme-light :not(pre) > code {
  background: #f3f3f3;
}
.ux-code.ux-code--theme-light :not(pre) > code {
  border-radius: 0.3em;
  padding: 0.1em;
  white-space: normal;
}
.ux-code.ux-code--theme-light .token.comment,
.ux-code.ux-code--theme-light .token.prolog,
.ux-code.ux-code--theme-light .token.doctype,
.ux-code.ux-code--theme-light .token.cdata {
  color: slategray;
}
.ux-code.ux-code--theme-light .token.punctuation {
  color: #999;
}
.ux-code.ux-code--theme-light .token.namespace {
  opacity: 0.7;
}
.ux-code.ux-code--theme-light .token.property,
.ux-code.ux-code--theme-light .token.tag,
.ux-code.ux-code--theme-light .token.boolean,
.ux-code.ux-code--theme-light .token.number,
.ux-code.ux-code--theme-light .token.constant,
.ux-code.ux-code--theme-light .token.symbol,
.ux-code.ux-code--theme-light .token.deleted {
  color: #905;
}
.ux-code.ux-code--theme-light .token.selector,
.ux-code.ux-code--theme-light .token.attr-name,
.ux-code.ux-code--theme-light .token.string,
.ux-code.ux-code--theme-light .token.char,
.ux-code.ux-code--theme-light .token.builtin,
.ux-code.ux-code--theme-light .token.inserted {
  color: #690;
}
.ux-code.ux-code--theme-light .token.operator,
.ux-code.ux-code--theme-light .token.entity,
.ux-code.ux-code--theme-light .token.url,
.ux-code.ux-code--theme-light .language-css .token.string,
.ux-code.ux-code--theme-light .style .token.string {
  color: #9a6e3a;
}
.ux-code.ux-code--theme-light .token.atrule,
.ux-code.ux-code--theme-light .token.attr-value,
.ux-code.ux-code--theme-light .token.keyword {
  color: #07a;
}
.ux-code.ux-code--theme-light .token.function,
.ux-code.ux-code--theme-light .token.class-name {
  color: #dd4a68;
}
.ux-code.ux-code--theme-light .token.regex,
.ux-code.ux-code--theme-light .token.important,
.ux-code.ux-code--theme-light .token.variable {
  color: #e90;
}
.ux-code.ux-code--theme-light .token.important,
.ux-code.ux-code--theme-light .token.bold {
  font-weight: bold;
}
.ux-code.ux-code--theme-light .token.italic {
  font-style: italic;
}
.ux-code.ux-code--theme-light .token.entity {
  cursor: help;
}

.ux-code.ux-code--theme-dark {
  /* Code blocks */
  /* Inline code */
}
.ux-code.ux-code--theme-dark code,
.ux-code.ux-code--theme-dark pre {
  color: #fff;
}
.ux-code.ux-code--theme-dark pre,
.ux-code.ux-code--theme-dark :not(pre) > code {
  background: #2c2c2c;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5) inset;
}
.ux-code.ux-code--theme-dark :not(pre) > code {
  border-radius: 0.3em;
  padding: 0.1em;
  white-space: normal;
}
.ux-code.ux-code--theme-dark .token.comment,
.ux-code.ux-code--theme-dark .token.prolog,
.ux-code.ux-code--theme-dark .token.doctype,
.ux-code.ux-code--theme-dark .token.cdata {
  color: hsl(30, 20%, 50%);
}
.ux-code.ux-code--theme-dark .token.punctuation {
  color: #999;
}
.ux-code.ux-code--theme-dark .token.namespace {
  opacity: 0.7;
}
.ux-code.ux-code--theme-dark .token.property,
.ux-code.ux-code--theme-dark .token.tag,
.ux-code.ux-code--theme-dark .token.boolean,
.ux-code.ux-code--theme-dark .token.number,
.ux-code.ux-code--theme-dark .token.constant,
.ux-code.ux-code--theme-dark .token.symbol {
  color: hsl(350, 40%, 70%);
}
.ux-code.ux-code--theme-dark .token.selector,
.ux-code.ux-code--theme-dark .token.attr-name,
.ux-code.ux-code--theme-dark .token.string,
.ux-code.ux-code--theme-dark .token.char,
.ux-code.ux-code--theme-dark .token.builtin,
.ux-code.ux-code--theme-dark .token.inserted {
  color: hsl(75, 70%, 60%);
}
.ux-code.ux-code--theme-dark .token.operator,
.ux-code.ux-code--theme-dark .token.entity,
.ux-code.ux-code--theme-dark .token.url,
.ux-code.ux-code--theme-dark .language-css .token.string,
.ux-code.ux-code--theme-dark .style .token.string,
.ux-code.ux-code--theme-dark .token.variable {
  color: hsl(40, 90%, 60%);
}
.ux-code.ux-code--theme-dark .token.atrule,
.ux-code.ux-code--theme-dark .token.attr-value,
.ux-code.ux-code--theme-dark .token.keyword {
  color: hsl(350, 40%, 70%);
}
.ux-code.ux-code--theme-dark .token.regex,
.ux-code.ux-code--theme-dark .token.important {
  color: #e90;
}
.ux-code.ux-code--theme-dark .token.important,
.ux-code.ux-code--theme-dark .token.bold {
  font-weight: bold;
}
.ux-code.ux-code--theme-dark .token.italic {
  font-style: italic;
}
.ux-code.ux-code--theme-dark .token.entity {
  cursor: help;
}
.ux-code.ux-code--theme-dark .token.deleted {
  color: red;
}

.ux-code {
  box-sizing: border-box;
  display: block;
  margin: 0 auto;
  position: relative;
}
.ux-code__copy {
  padding: 0.25em;
  position: absolute;
  right: 0;
  top: 0;
}
.ux-code__copy-btn {
  background: rgba(255, 255, 255, 0.75);
  border: 0 none transparent;
  border-radius: 0.25em;
  box-shadow: 0 0 0.25em rgba(0, 0, 0, 0.1);
  color: #000;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  padding: 0.5em 0.75em;
}
.ux-code__copy .ux-icon {
  fill: currentcolor;
  margin-left: 0.5em;
}
.ux-code code,
.ux-code pre {
  font-family: monospace;
  font-size: 14px;
  font-weight: normal;
  hyphens: none;
  line-height: 1.5;
  tab-size: 4;
  text-align: left;
  white-space: pre;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
}
.ux-code pre {
  margin: 0;
  overflow: auto;
  padding: 1em;
}
.ux-code--line-numbers pre {
  padding-left: 3em;
}
.ux-code__rows {
  background: #f3f3f3;
  left: 0;
  padding: 1em 0.5em;
  position: absolute;
  top: 0;
}
.ux-code__rows > span {
  display: block;
  opacity: 0.5;
}
.ux-code--theme-dark .ux-code__copy-btn {
  background: transparent;
  color: #fff;
}
.ux-code--theme-dark .ux-code__rows {
  background: #2c2c2c;
}
.ux-code pre::selection,
.ux-code pre ::selection,
.ux-code code::selection,
.ux-code code ::selection {
  background: #b3d4fc;
  color: #000;
  text-shadow: none;
}
.ux-code--inline {
  display: inline;
}
.ux-code--inline pre {
  display: inline;
  padding: 0.2em 0.4em;
}